<template>
  <div>
    <form-renderer
      :title="$t('exports.title', { resource: $t(`exports.resources.${type}`) })"
      class="form-export-resource"
      form-wrapper-class="flex-layout justify-start"
      :model="model"
      :fields="fields"
      :fields-objects="fieldsObjects"
      :loading="exporting"
      submit-button-label="form.button.export"
      :disable-submit="submitDisabled"
      @updateModel="onUpdate"
      @onSave="onExport"
    >
      <template slot="topArea">
        <span role="button" :class="{ 'action': true, active: allFieldsSelected }" @click="onToggleSelectAll(true)">{{$t("form.button.select_all")}}</span>
        <span role="button" :class="{ 'action': true, active: noFieldsSelected }" @click="onToggleSelectAll(false)">{{ $t("form.button.clear_all")}}</span>
      </template>
      <template v-if="text" slot="beforeFields">
        <div class="alert alert-secondary">
          <div class="text-sm">{{text}}</div>
        </div>
      </template>
    </form-renderer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { normalize } from "../../helpers/pagination";
import { removeEmptyProps } from "../../helpers/object";
import { download_blob } from "../../helpers/download_file";
import { FIELD_TYPE } from "../../config/const";
import FormRenderer from "../form-renderer";

export default {
  props: {
    type: {
      type: String,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    ids: {
      type: Array
    },
    translationPath: {
      type: String
    },
    params: {
      type: Object,
      default: () => {}
    },
    text: {
      type: String
    }
  },

  data: function () {
    const model = {};

    for (let i = 0; i < this.fields.length; i++) {
      const f = this.fields[i];
      model[f] = true;
    }

    return {
      model,
      exporting: false
    }
  },

  computed: {
    fieldsObjects () {
      const data = {};
      for (let i = 0; i < this.fields.length; i++) {
        const f = this.fields[i];
        data[f] = {
          id: f,
          name: f,
          type: FIELD_TYPE.CHECKBOX,
          translate_label: `${this.translationPath || this.type}.${f}`,
          style: "flex: 0 0 25%",
          customClass: "mb20",
          labelPosition: "right",
          inputWrapperClass: "items-center"
        }
      }
      return data;
    },

    submitDisabled () {
      const model = this.model;
      return Object.keys(model).filter(key => model[key] === true).length === 0;
    },

    allFieldsSelected () {
      return this.fields.filter(f => this.model[f] === true).length === this.fields.length;
    },

    noFieldsSelected () {
      return this.fields.filter(f => this.model[f] === true).length === 0;
    },

    ...mapState({
      user: state => state.user.user.data || {}
    })
  },

  methods: {
    onToggleSelectAll (selecting) {
      const model = this.model;
      for (let i = 0; i < this.fields.length; i++) {
        const f = this.fields[i];
        model[f] = selecting;
      }
      this.model = model;
    },

    onUpdate (model) {
      this.model = model;
    },

    onExport () {
      this.exporting = true;

      const projectId = this.$route.params.project_uid;
      const user = this.user;
      const resourceType = this.type;

      const ids = this.ids || [];
      const columns = Object.keys(this.model).filter(key => this.model[key] === true);

      const params = this.params ? this.normalizeParams(this.params) : {};

      const data = {
        ids,
        columns,
        ...params
      }
      
      const fileName = `${resourceType}_${Date.now()}`;

      download_blob(`analysis/${projectId}/export/${resourceType}`, data, user.accessToken, fileName)
        .then(r => {
          this.exporting = false;
        })
        .catch(error => {
          console.error(error);
          this.exporting = false;
          this.$notify({
            group: "store_notifications",
            type: "error",
            text: this.$t("messages.request.error")
          });
        });
    },

    normalizeParams (params) {
      const data = {};
      const keys = Object.keys(params);
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        if (params[key] && typeof params[key] === "object" && !(params[key] instanceof Array) && Object.keys(params[key]).length > 0) {
          data[key] = this.normalizeParams(params[key]);
        } else {
          const normalized = removeEmptyProps(normalize({ [key]: params[key] }));
          const normalizedKeys = Object.keys(normalized);
          for (let j = 0; j < normalizedKeys.length; j++) {
            const k = normalizedKeys[j];
            data[k] = normalized[k];
          }
        }
      }
      return data;
    }
  },

  components: {
    FormRenderer
  }
}
</script>
<style lang="scss">
  @import "../../styles/components/coding-admin/form_export_resource";
</style>